import axios from "axios";
const reqUrl = "https://psbcpay.kunxiangparking.cn"; //正式
// const reqUrl = "http://172.16.10.98:30000/venue"; //杨磊
// const reqUrl = "http://172.16.10.254:30000/venue"; //文博
// const reqUrl = "http://172.16.10.93:30000/venue"; //浩印
// const reqUrl = "http://172.16.10.17:30000/venue"; //浩印
// const reqUrl = "http://172.16.10.11:30000/venue"; //张柯
// const reqUrl = "http://172.16.10.87:30000/venue"; //工控机
const request = axios.create({
  baseURL: reqUrl,
  headers: { "Content-Type": "application/json" },
  timeout: 120 * 1000
});

// 请求拦截器

request.interceptors.request.use(
  config => {
    console.log(config);
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  function(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function(error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);
export default request;
